import { Checkbox, DropDownList } from "@repo/ui";

import type { LayerFilterProps } from "../hooks/useUpdateLayerFilter";

import { DateRangeFilter } from "./dateRangeFilter";
import { EnrollmentIdFilter } from "./enrollmentIdFilter";
import { LayerMachinesDropdown, LayerRepsDropdown } from "./entityDropdowns";
import { SegmentDropdowns } from "./segmentDropdowns";

const PHONE_CARRIER_OPTIONS = [
	{ label: "All", value: "" },
	{ label: "Landline", value: "landline" },
	{ label: "Mobile", value: "mobile" },
	{ label: "VoIP", value: "voip" },
];

export function SalesFilter({ layer, updateFilter }: LayerFilterProps) {
	return (
		<>
			<SegmentDropdowns layer={layer} updateFilter={updateFilter} clientSide={false} />
			<LayerRepsDropdown layer={layer} updateFilter={updateFilter} />
			<LayerMachinesDropdown layer={layer} updateFilter={updateFilter} />
			<EnrollmentIdFilter layer={layer} updateFilter={updateFilter} />
			<DateRangeFilter layer={layer} updateFilter={updateFilter} />
			<Checkbox
				id="goodSales"
				label="Show Good Sales Only"
				value={layer.goodSales ?? false}
				changeHandler={(checked: boolean) => updateFilter(checked || undefined, "goodSales")}
				inline
			/>
			<DropDownList
				id="phoneCarrierType"
				label="Phone Carrier"
				fullLength
				value={layer.phoneCarrierType}
				changeHandler={updateFilter}
				values={PHONE_CARRIER_OPTIONS}
			/>
		</>
	);
}
